import Vue from "vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import { mapState } from "vuex"
import store from "@hub/core/src/store"

import VueFeather from "vue-feather"

const ICONS_FEEDBACK = {
  warn: "exclamation-circle",
  error: "exclamation-circle",
  success: "check-circle",
  info: "info-circle"
}

import "./styles.scss"

export const VToast = {
  name: "VToast",
  data: () => ({
    auto: {
      show: false
    }
  }),
  props: {
    title: {
      type: String,
      default: "Toast Heading"
    },
    type: {
      type: String,
      default: "info",
      validator: type => ["warn", "info", "success", "error"].includes(type)
    },
    show: {
      type: Boolean,
      default: false
    },
    prevHeader: {
      type: Boolean,
      default: true
    },
    autoPlay: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("Auth", ["getShowModalLogin"])
  },
  mounted() {
    if (this.autoPlay) {
      setTimeout(() => {
        this.auto.show = true
      }, 200)

      setTimeout(() => {
        this.auto.show = false
      }, 10000)
    }
  },
  render(h) {
    const { title, type, show, prevHeader } = this

    return (
      <div
        class={[
          "v-toast",
          `v-toast--${type}`,
          {
            "v-toast--show": this.autoPlay ? this.auto.show : show,
            "v-toast--prev-header": prevHeader
          }
        ]}
      >
        <FontAwesomeIcon class="v-toast__icon" icon={ICONS_FEEDBACK[type]} />
        <p class="v-toast__title">{title}</p>
        <span class="v-toast__icon-close">
          <VueFeather type="x" onClick={event => (this.auto.show = false)} />
        </span>
      </div>
    )
  }
}

const NAME_LOGIN_ROUTE = "hub"

const isAtLoginPage = () => {
  const isAtLoginPage =
    window.$vue.$router.currentRoute.name == NAME_LOGIN_ROUTE
  return isAtLoginPage
}

const hideToastIfModalLoginIsOpen = () => {
  const showModalLogin = store.getters["Auth/getShowModalLogin"]
  return !isAtLoginPage() && showModalLogin
}

export const toastProgrammatic = props => {
  if (hideToastIfModalLoginIsOpen() && !props.showLoginRequestToast) {
    return
  }

  const propsData = {
    title: "Toast",
    type: "info",
    autoPlay: true,
    prevHeader: true,
    ...props
  }

  const state = {
    htmlElementToInsertToast: ""
  }

  const ComponentClass = Vue.extend(VToast)
  const instance = new ComponentClass({ propsData })
  instance.$mount()

  state.htmlElementToInsertToast =
    document.querySelector("main") || document.body

  const toast = state.htmlElementToInsertToast.appendChild(instance.$el)
  setTimeout(() => {
    toast.remove()
  }, 10000)
}

export default VToast
